import { Component, EventEmitter, Input, Output } from '@angular/core';
import { HColor } from '@shared/src/datatypes/HColor';
import { AccessControlGatePlateDto } from '@shared/src/dtos/accesscontrol/gate/plate/AccessControlGatePlateDto';
import { DragDropService } from '@shared/src/services/dragdrop/DragDropService';

@Component({
    selector: 'shared-forklift-left-route',
    templateUrl: './shared.forklift.left.route.component.html',
    styleUrls: ['./shared.forklift.left.route.component.scss']
})
export class SharedForkliftLeftRouteComponent {

    constructor(public dragDropService: DragDropService) { }

    @Input() public selectedRoute: AccessControlGatePlateDto | null = null;
    @Output() public clickRoute = new EventEmitter<AccessControlGatePlateDto>();
    @Output() public dblClickRoute = new EventEmitter<AccessControlGatePlateDto>();

    public backgroundColor: string = "#ffffff";

    private _value: AccessControlGatePlateDto | null = null;
    @Input() public set value(v: AccessControlGatePlateDto) {
        this._value = v;
        this.backgroundColor = HColor.getColor(v?.backgroundColor, 'ffffff');
    }
    public get value(): AccessControlGatePlateDto | null {
        return this._value;
    }

    onDragStart(event: DragEvent) {
        if (this.value == null) return;
        DragDropService.moverOrCopy(event);
        event.dataTransfer.setData(DragDropService.TEXTPLAIN, DragDropService.HARDMAN_ACCESSCONTROLGATEPLATEDTO);
        event.dataTransfer.setData(DragDropService.HARDMANTYPE, JSON.stringify(this.value));
    }

    public pretty(value: any): string {
        return JSON.stringify(value);
    }
}
